<template>
  <div class="dashboard">
    <div class="welcom">
      <Icon class="uicon" type="ios-cafe" />
      您好 <span class="uname">{{$store.state.uinfo.group_name||''}} / {{$store.state.uinfo.relname||''}}</span>，欢迎使用<span class="uname">庆丰裕产品图库</span>后台管理系统。现在时间是：{{nowTime}}
    </div>
    <div class="tips">
      <Icon class="ticon" type="ios-notifications" />
      本页数据会自动更新，无需手动刷新~
    </div>
    <div class="dashlis" v-if="loaded1">
      <div class="dastit"><span class="dasico iconfont">&#xe62c;</span>待处理事项</div>
      <div class="dalsw">
        <div class="lisitem">
          <div class="dalis" @click="opentags('/goodslist')">
            <div class="watico iconfont" style="font-size: 30px; color: #69c0ff;">&#xe6bf;</div>
            <div class="wattext">产品总数(<span :class="[data.goods_tot?'warring':'']">{{data.goods_tot||0}}</span>)</div>
          </div>
          <div class="dalis">
            <div class="watico iconfont" style="font-size: 28px; color: #b37feb;">&#xe67c;</div>
            <div class="wattext">图片总数(<span :class="[data.img_tot?'warring':'']">{{data.img_tot||0}}</span>)</div>
          </div>
          <div class="dalis" @click="opentags('/checkimg')">
            <div class="watico iconfont" style="font-size: 28px; color: #FF9900;">&#xe7d0;</div>
            <div class="wattext">图片待审(<span :class="[data.img_check?'warring':'']">{{data.img_check||0}}</span>)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data(){
    return {
      nowTime:'--',
      data:{},
      timer:{
        timer1:null,
        timer2:null,
      },
      loaded1:false,
      loaded2:false
    }
  },
  activated(){
    clearInterval(this.timer.timer1);
    clearInterval(this.timer.timer2);
    this.timer.timer1=setInterval(this.getTime,1000);
    this.getPreview();
    this.timer.timer2=setInterval(this.getPreview,20000);
  },
  methods:{
    /**
     * 刷新
     */
    reload:function (){
      this.getPreview();
    },
    /**
     * 获取当前时间
     */
    getTime:function (){
      let date=new Date(),
          Y=date.getFullYear(),
          m=date.getMonth()+1,
          d=date.getDate(),
          H=date.getHours(),
          i=date.getMinutes(),
          s=date.getSeconds();
      m= (m+1) < 10 ? "0" + m.toString() : m;
      d= d < 10 ? "0" + d.toString() : d;
      H= H < 10 ? "0" + H.toString() : H;
      i= i < 10 ? "0" + i.toString() : i;
      s= s < 10 ? "0" + s.toString() : s;
      this.nowTime=Y+'-'+m+'-'+d+' '+H+':'+i+':'+s;
    },
    /**
     * 获取数据预览
     */
    getPreview:function (){
      var _this=this;
      this.requestApi('/adm/preview_data.html').then(function (res){
        if(res.status==1){
          _this.data=res.data;
          _this.loaded1=true;
        }
      })
    }
  },
  beforeRouteLeave(to,from,next) {
    clearInterval(this.timer.timer1);
    clearInterval(this.timer.timer2);
    next();
  }
}
</script>
<style lang="less">
@import "~@/assets/css/dashboard/dashboard";
</style>
